import { CUSTLOG_INIT_LOADING, CUSTLOG_INIT_SUCCESS, CUSTLOG_INIT_FAIL } from '@/store/types'

export const custLog = {
  [CUSTLOG_INIT_LOADING](state) {
    state.customerLogSettings.init = 0
    state.customerLogSettings.menu = {}
    state.customerLogSettings.initErr = []
  },
  [CUSTLOG_INIT_SUCCESS](state, data) {
    state.customerLogSettings.init = 1
    state.customerLogSettings.menu = data.menu
    state.customerLogSettings.initErr = []
  },
  [CUSTLOG_INIT_FAIL](state, err) {
    state.customerLogSettings.init = 2
    state.customerLogSettings.menu = {}
    state.customerLogSettings.initErr = err
  }
}
